import { sleep } from './global';
import { register } from './message-router';
import { socketManager } from './network';
import { appendMessage, chatInput, getSpinnerHTML, currentChatIndex } from './chatbot';

const { wsVoiceUrl } = socketManager;

let mediaRecorder: MediaRecorder | null = null;

const voiceBtn = document.getElementById('voice-btn') as HTMLButtonElement;

const processingMsg: HTMLDivElement[] = [];

voiceBtn.addEventListener('click', async () => {
  if (!mediaRecorder) {
    await startRecording();
  } else {
    stopRecording();
  }
});

async function startRecording(): Promise<void> {
  // UI Updates: Turn button red and pulse
  voiceBtn.classList.remove('bg-blue-600', 'hover:bg-blue-700');
  voiceBtn.classList.add('bg-red-600', 'hover:bg-red-700', 'animate-pulse');

  const placeholderMsg = chatInput?.placeholder || '';
  if (chatInput) {
    chatInput.placeholder = "Listening...";
  }

  const voiceWs = new WebSocket(`${wsVoiceUrl}/${currentChatIndex}`);
  voiceWs.binaryType = "arraybuffer";

  voiceWs.onopen = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/webm;codecs=opus" });
    let pendingSends = 0;

    mediaRecorder.ondataavailable = async (e: BlobEvent) => {
      if (e.data.size > 0 && voiceWs.readyState === WebSocket.OPEN) {
        pendingSends++;
        try {
          voiceWs.send(await e.data.arrayBuffer());
        } finally {
          pendingSends--;
        }
      }
    };

    mediaRecorder.onstop = async () => {
      // Wait for all pending sends to complete and WebSocket buffer to drain
      while (pendingSends > 0 || voiceWs.bufferedAmount > 0) {
        await sleep(50);
      }
      voiceWs.close();

      // UI Reset
      voiceBtn.classList.add('bg-blue-600', 'hover:bg-blue-700');
      voiceBtn.classList.remove('bg-red-600', 'hover:bg-red-700', 'animate-pulse');
      if (chatInput) {
        chatInput.placeholder = placeholderMsg;
      }

      // Add visual indicator that we are processing
      processingMsg.push(
        appendMessage('user', '', '', getSpinnerHTML('Processing audio...'))
      );
    };

    mediaRecorder.start(250);
  };
}

function stopRecording(): void {
  if (mediaRecorder) {
    // Flush any remaining buffered audio data before stopping
    mediaRecorder.requestData();
    mediaRecorder.stop();
    mediaRecorder.stream.getTracks().forEach(track => track.stop());
    mediaRecorder = null;
  }
}

register('voice', () => {
  processingMsg.shift()?.remove();
});

// export { startRecording, stopRecording };
